<template>
  <basic-container>
    <avue-crud v-if="reWrite"
               :option="option"
               :table-loading="loading"
               :data="data"
               :page.sync="page"
               ref="crud"
               @row-del="rowDel"
               v-model="form"
               :permission="permissionList"
               @row-update="rowUpdate"
               @row-save="rowSave"
               :before-open="beforeOpen"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @size-change="sizeChange"
               @refresh-change="refreshChange"
               @on-load="onLoad">
      <template slot="menuLeft">
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          v-if="permission.device_add"
          @click="exportExcel"
        >导出通知公告数据
        </el-button>
        <el-button type="danger"
                   size="small"
                   icon="el-icon-delete"
                   plain
                   v-if="permission.notice_delete"
                   @click="handleDelete">删 除
        </el-button>
      </template>
      <template slot-scope="{row}"
                slot="category">
        <el-tag>{{row.categoryName}}</el-tag>
      </template>
    </avue-crud>
  </basic-container>
</template>

<script>
  import {getList, remove, update, add, getNotice,getNewestNotice,getProjectNoticePage} from "@/api/crmedical/notice/v4ward-notice";
  import {getProjectList,getDetail} from "@/api/crmedical/project/project";
  import {mapGetters} from "vuex";
  import {getToken} from '@/util/auth';

  export default {
    data() {
      return {
        form: {},
        projectList:[],
        query: {},
        loading: true,
        firstDisplayFlag: false,
        reWrite: false,
        tempProjectId:'',
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {
          height: 'auto',
          calcHeight: 30,
          dialogWidth: 950,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          index: true,
          indexLabel:"序号",
          viewBtn: true,
          columnBtn: false,
          selection: true,
          // excelBtn: true,
          dialogClickModal: false,
          // gutter:30,
          // labelWidth: 180,
          column: [
            {
              label: "项目名称",
              prop: "projectId",
              type: "select",
              editDisabled: true,
              span: 12,
              searchSpan:8,
              dicUrl: "/api/v4ward/project/getProjectList",
              // row: true,
              search: true,
              props: {
                label: "name",
                value: "id"
              },
              rules: [{
                required: true,
                message: "请选择项目名称",
                trigger: "blur"
              }]
            },
            {
              label: "通知标题",
              prop: "title",
              span: 24,
              searchSpan:8,
              row: true,
              search: true,
              maxlength:60,
              rules: [{
                required: true,
                message: "请输入通知标题",
                trigger: "blur"
              }]
            },
            {
              label: "通知类型",
              type: "select",
              searchSpan:8,
              dicUrl: "/api/blade-system/dict/dictionary?code=notice",
              props: {
                label: "dictValue",
                value: "dictKey"
              },
              dataType: "number",
              prop: "category",
              search: true,
              rules: [{
                required: true,
                message: "请选择通知类型",
                trigger: "blur"
              }]
            },
            {
              label: "开始时间",
              prop: "releaseTime_datege",
              editDisplay: false,
              addDisplay: false,
              viewDisplay: false,
              hide:true,
            },
            {
              label: "结束时间",
              prop: "releaseTime_datelt",
              editDisplay: false,
              addDisplay: false,
              viewDisplay: false,
              hide:true,
            },
            {
              label: "通知时间",
              prop: "releaseTimeRange",
              searchSpan:12,
              type: "datetimerange",
              showColumn:false,
              format: "yyyy-MM-dd hh:mm:ss",
              valueFormat: "yyyy-MM-dd hh:mm:ss",
              searchRange:true,
              hide: true,
              addDisplay: false,
              editDisplay: false,
              viewDisplay: false,
              search: true,
              rules: [{
                required: true,
                message: "请输入通知时间",
                trigger: "blur"
              }]
            },
            {
              label: "通知日期",
              prop: "releaseTime",
              type: "date",
              format: "yyyy-MM-dd hh:mm:ss",
              valueFormat: "yyyy-MM-dd hh:mm:ss",
              rules: [{
                required: true,
                message: "请选择通知日期",
                trigger: "click"
              }]
            },
            {
              label: "通知内容",
              prop: "content",
              showColumn:false,
              component: 'AvueUeditor',
              options: {
                action: '/api/blade-resource/oss/endpoint/put-file',
                props: {
                  res: "data",
                  url: "link",
                }
              },
              hide: true,
              minRows: 6,
              span: 24,
            }
          ]
        },
        data: []
      };
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.notice_add, false),
          viewBtn: this.vaildData(this.permission.notice_view, false),
          delBtn: this.vaildData(this.permission.notice_delete, false),
          editBtn: this.vaildData(this.permission.notice_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    created() {
      getProjectList().then((response)=>{
        console.log(this.query);
        this.projectList=response.data;
        if (this.projectList.length>0){
          this.tempProjectId=response.data[0].id;
          this.query.projectId=response.data[0].id;
        }
        this.$nextTick(() => {
          this.reWrite = true;
        });
        //每次刷新页面时，开启房产搜索框默认显示第一个节点的名称
        this.firstDisplayFlag = true;
      });
    },
    methods: {
      exportExcel() {
        this.$confirm("是否导出最近一次查询的通知公告数据?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          //导出数据
          let projectId = '';
          if (this.query.projectId) {
            projectId = this.query.projectId;
          }
          let title = '';
          if (this.query.title) {
            title = this.query.title;
          }
          let category = '';
          if (this.query.category) {
            category = this.query.category;
          }
          let releaseTime_datege = '';
          if (this.query.releaseTime_datege) {
            releaseTime_datege = this.query.releaseTime_datege;
          }
          let releaseTime_datelt = '';
          if (this.query.releaseTime_datelt) {
            releaseTime_datelt = this.query.releaseTime_datelt;
          }
          window.open(`/api/v4ward/notice/noticeExport?${this.website.tokenHeader}=${getToken()}&projectId=${projectId}&title=${title}&category=${category}&releaseTime_datege=${releaseTime_datege}&releaseTime_datelt=${releaseTime_datelt}&current=${this.page.currentPage}&size=${this.page.pageSize}`);
        });
      },
      getProjectNameById(projectId) {
        let projectName = '';
        this.projectList.forEach(function (value, index, array) {
          if (value.id === projectId) {
            projectName = value.name;
            return;
          }
        });
        return projectName;
      },
      rowSave(row, done, loading) {
        if (row.content.length>2000){
          this.$message.error("内容最大长度为2000字")
          return loading();
        }
        add(row).then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowUpdate(row, index, done, loading) {
        if (row.content.length>2000){
          this.$message.error("内容最大长度为2000字")
          return loading();
        }
        update(row).then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!"
          });
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove(row.id);
          })
          .then(() => {
            this.onLoad(this.page);
            this.$message({
              type: "success",
              message: "操作成功!"
            });
          });
      },
      searchReset() {
        let queryClone =  JSON.parse(JSON.stringify(this.query));
        let ent = document.querySelector('input[placeholder="项目名称"]');
        getDetail(Object.assign({id:queryClone.projectId})).then(res=>{
          console.log(res.data);
          ent.value=res.data.name;
        })
        this.query = {};
        this.query.projectId=queryClone.projectId;
        this.onLoad(this.page);
      },
      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad(this.page, params);
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove(this.ids);
          })
          .then(() => {
            this.onLoad(this.page);
            this.$message({
              type: "success",
              message: "操作成功!"
            });
            this.$refs.crud.toggleSelection();
          });
      },
      beforeOpen(done, type) {
        if (["edit", "view"].includes(type)) {
          getNotice(this.form.id).then(res => {
            this.form = res.data.data;
          });
        }
        done();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      refreshChange() {
        this.onLoad(this.page, this.query);
      },
      onLoad(page) {
        if (this.query.releaseTimeRange) {
          this.query.releaseTime_datege = this.query.releaseTimeRange[0];
          this.query.releaseTime_datelt = this.query.releaseTimeRange[1];
          this.query.releaseTimeRange=null;
        }
        // let values = {
        //   ...params,
        // };
        // if (releaseTimeRange) {
        //   values = {
        //     ...params,
        //     releaseTime_datege: releaseTimeRange[0],
        //     releaseTime_datelt: releaseTimeRange[1],
        //   };
        //   values.releaseTimeRange = null;
        //   this.query.releaseTimeRange = null;
        // }
        this.loading = true;
        if (!this.query.projectId) {
          this.query.projectId = this.tempProjectId;
        }
        getList(Object.assign({current: page.currentPage, size: page.pageSize}, this.query)).then(res => {
          const data = res.data.data;
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();

          if (this.firstDisplayFlag) {
            let ent = document.querySelector('input[placeholder="项目名称"]');
            ent.value = this.projectList[0].name;
            this.tempProjectId = this.query.projectId;
            //关闭默然显示，重刷页面时才开启默认显示
            this.firstDisplayFlag = false;
          }
        });
      }
    }
  };
</script>

<style>
</style>
